/** The optional version marker must not prevent React from mounting.
 * Return failed writes to the caller so a stale marker cannot cause a reload loop.
 * Keep the storage getter inside the catch boundary: blocked storage can throw there too.
 */

export const SW_VERSION_KEY = 'vidi-sw-version';

type StorageGetter = () => Pick<Storage, 'getItem' | 'setItem'>;

const defaultStorage: StorageGetter = () => window.localStorage;

/** Returns the stored marker, or null when empty or storage is unusable. */
export function readStoredSwVersion(getStorage: StorageGetter = defaultStorage): string | null {
  try {
    return getStorage().getItem(SW_VERSION_KEY);
  } catch {
    return null;
  }
}

/** Returns true only if the marker was written; false on any storage failure. */
export function writeStoredSwVersion(
  version: string,
  getStorage: StorageGetter = defaultStorage,
): boolean {
  try {
    getStorage().setItem(SW_VERSION_KEY, version);
    return true;
  } catch {
    return false;
  }
}
